export default {
  RequestForm: {
    label: {
      candidateFirstName: 'Driver First Name',
      candidateLastName: 'Driver Last Name',
      candidatePhone: 'Driver Phone #',
      candidateEmail: 'Driver Email',
      candidateEmployeeId: 'Alpha Code',
      documentsNeeded: 'Documents Needed',
    },
    btn: {
      submit: 'Request',
    },
  },
};
